import { createSelector } from "@reduxjs/toolkit";

export const singleEvidenceState = (state) => state.singleEvidence;

export const singleEvidenceSelectors = createSelector(singleEvidenceState, (state) => state);
